











































































































































































































































import { ICouponDetails } from "@/vuex/modules/coupon/interfaces";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Action } from "vuex-class";

@Component
export default class DetailsCompetitor extends Vue {
  @Prop(Object) coupon!: ICouponDetails;

  @Action("downloadPdf", { namespace: "coupon" })
  downloadPdf!: (path: string) => Promise<Blob>;

  downloadPdfSouEnergy(id:string): void {
    // let url = 'https://souenergy.fillet-digital.com.br/admin/orcamento/cart/generated/id/'+id+'/key/9412209cf5ffccf3491ce38b9a7f7611329234269a75ebafafc0ed0ec0dfc39a/'
    // console.log(url)
    // window.open('https://souenergy.fillet-digital.com.br/admin/orcamento/cart/generated/id/'+id+'/key/9412209cf5ffccf3491ce38b9a7f7611329234269a75ebafafc0ed0ec0dfc39a/ ', 'Orçamento SouEnergy', "_blank"); 
  }
  downloadPdfCompetitor(): void {
    this.downloadPdf(this.coupon.competition_budget_pdf).then((response) => {
      window.open(window.URL.createObjectURL(response), "_blank");
    });
  }
}
